import React, { memo } from 'react'
import dynamic from 'next/dynamic'
import Page from 'components/layout/Page'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Faqs from 'components/FaqsPage/Faqs'
import { useIntl } from 'react-intl'
import MainBanner from 'components/shared/MainBanner'
import Buttons from 'components/shared/MainBanner/Buttons'
import HightlightText from 'components/shared/HightlightText'
import TimelineAndVideo from 'components/shared/TimelineAndVideo'
import InternalSection from 'components/shared/InternalSection'
import GoogleReviewsAndPress from 'components/shared/GoogleReviewsAndPress'
import usePageProps from 'hooks/usePageProps'
import sx from './styles'

const RatingComponent = dynamic(
  () => import('components/shared/Rating'),
  {
    loading: () => (
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={160}
        width="100%"
      />
    ),
    ssr: false,
  },
)

const VehicleTypesComponent = dynamic(
  () => import('components/shared/Swipers/VehicleTypes'),
  {
    loading: () => (
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={160}
        width="100%"
      />
    ),
    ssr: false,
  },
)

function Financing() {
  const { formatMessage: f } = useIntl()
  const {
    financingFaqsSection,
    timeline,
    mainBanner,
    internalSections,
  } = usePageProps()
  return (
    <Page>
      <MainBanner
        {...mainBanner}
        sx={{ paddingY: { xs: 3, lg: 4 } }}
      >
        <Buttons
          items={mainBanner?.buttons}
          disclaimer={mainBanner?.disclaimer}
        />

      </MainBanner>

      <HightlightText
        title={f(
          { id: 'FINANCING_HIGHLIGHTED_TEXT' },
          {
            soldNumber: '550',
            span: (chunks) => <span>{chunks}</span>,
          },
        )}
      />

      <Box sx={sx.linearGradient}>
        <Grid
          size={12}
          container
        >
          <Grid size={12}>
            <TimelineAndVideo
              data={timeline}
              sxImg={{ height: { xs: 170, lg: 438 } }}
            >
              <VehicleTypesComponent
                title={f({ id: 'FIND_THE_PERFECT_VEHICLE' })}
                varaintTitle="h2"
                redirectToSRP
              />
            </TimelineAndVideo>
          </Grid>

          <Grid size={12}>
            <RatingComponent
              text={f({ id: 'FINANCING_RATING_TEXT' })}
              textVariant="h3"
              sx={{
                '& .MuiGrid2-root.MuiGrid-container': {
                  py: 0,
                  pt: 3,
                },
              }}
            />
          </Grid>

          <Grid size={12}>
            <InternalSection
              sx={sx.internalSection}
              data={internalSections}
              shoGoToHomeButton={false}
            />
          </Grid>
        </Grid>
      </Box>

      <Faqs
        variant="row"
        data={financingFaqsSection}
        title="FAQS_TITLE"
        showContactUs
        sx={{ marginY: 6 }}
      />

      <GoogleReviewsAndPress
        variant="row"
        title="REVIEWS_TITLE"
        sx={sx.googleReviewsContainer}
      />
    </Page>
  )
}

export default memo(Financing)
